export const valuationQueryKeys = {
  _base: () => ["valuation"],
  all: (agencyId: string) => [...valuationQueryKeys._base(), { agencyId }],
  single: (agencyId: string, valuationId: string) => [
    ...valuationQueryKeys.all(agencyId),
    "single",
    { valuationId },
  ],
  byPerson: (agencyId: string, personId?: string) => [
    ...valuationQueryKeys.all(agencyId),
    "byPerson",
    { personId },
  ],
};
